export type JobType =
  | "productsCsvImport"
  | "productsCsvDownload"
  | "editPricesProducts"
  | "customerCsvDownload"
  | "customersCsvImport"
  | "ordersCsvDownload"
  | "deleteLocation"
  | "cloneProduct"
  | "assignCategories";

export const jobType: Record<JobType, { hasCsvDownload: boolean }> = {
  editPricesProducts: {
    hasCsvDownload: false,
  },
  productsCsvImport: {
    hasCsvDownload: false,
  },
  productsCsvDownload: {
    hasCsvDownload: true,
  },
  customerCsvDownload: {
    hasCsvDownload: true,
  },
  customersCsvImport: {
    hasCsvDownload: false,
  },
  ordersCsvDownload: {
    hasCsvDownload: true,
  },
  deleteLocation: {
    hasCsvDownload: false,
  },
  cloneProduct: {
    hasCsvDownload: false,
  },
  assignCategories: {
    hasCsvDownload: false,
  },
};
